import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=0c1459ee"
import script from "./FontSelector.vue?vue&type=script&lang=js"
export * from "./FontSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c1459ee')) {
      api.createRecord('0c1459ee', component.options)
    } else {
      api.reload('0c1459ee', component.options)
    }
    module.hot.accept("./FontSelector.vue?vue&type=template&id=0c1459ee", function () {
      api.rerender('0c1459ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/FontSelector.vue"
export default component.exports